// extracted by mini-css-extract-plugin
module.exports = {"checkBoxElement":"oQbV9tjfcbfhfJMmw_Axh"};